import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useProfessionalsChartsDataContext } from './hooks/useProfessionalsChartsDataContext';

export const AnnualEvolution = () => {
    const { chartData } = useProfessionalsChartsDataContext();


    return (
        <SimpleBars
            title={'Evolução Anual do Total de Profissionais - Estratificada'}
            horizontal={false}
            subtitles={chartData?.annualEvolution?.map((item) => item.description)}
            values={chartData?.annualEvolution?.map((item) => item.total  ||  0)}
        />
    );
};
